module.exports = __webpack_public_path__ + "static/media/codechef.70c816a3.png";